"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollableItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var ScrollContext_1 = require("./ScrollContext");
/**
 * @internal
 */
exports.ScrollableItem = function (props) {
    var item = react_1.useRef(null);
    var scroll = ScrollContext_1.useScrollContext();
    var scrollIntoView = props.scrollIntoView, bottomMargin = props.bottomMargin, isElementInvisibleCheck = props.isElementInvisibleCheck, className = props.className, children = props.children, _a = props.tagName, TagName = _a === void 0 ? "div" : _a;
    react_1.useEffect(function () {
        if (scrollIntoView) {
            var element = item.current;
            scroll.scrollIntoView(element, bottomMargin, isElementInvisibleCheck);
        }
    }, [bottomMargin, isElementInvisibleCheck, scroll, scrollIntoView, item]);
    return (react_1.default.createElement(TagName, { className: className, ref: item }, children));
};
//# sourceMappingURL=ScrollableItem.js.map